export default __webpack_public_path__ + "static/media/PhantomSans0.8-Medium.3fe7b479.woff";